export var Decision = /*#__PURE__*/function (Decision) {
  Decision["RECURLY"] = "RECURLY";
  Decision["CHEGG"] = "CHEGG";
  return Decision;
}({});
export var DecisionReason = /*#__PURE__*/function (DecisionReason) {
  DecisionReason["NEW"] = "NEW";
  DecisionReason["CDP"] = "CDP";
  DecisionReason["PREVIOUS_ORDER"] = "PREVIOUS_ORDER";
  DecisionReason["NOT_ALLOCATED"] = "NOT_ALLOCATED";
  DecisionReason["COUNTRY_NOT_ALLOWED"] = "COUNTRY_NOT_ALLOWED";
  return DecisionReason;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/digital-pricing-bff.types.js
// module id = 4071
// module chunks = 11